import { render, staticRenderFns } from "./PieChartForm.vue?vue&type=template&id=dd416cea&scoped=true&"
import script from "./PieChartForm.vue?vue&type=script&lang=js&"
export * from "./PieChartForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd416cea",
  null
  
)

export default component.exports